import type React from 'react'

import { clsJoin } from '@/utils'
import type { SeoBlockType } from '../SeoBlockOrPlaceholder'
import css from './styles.module.css'

interface Props {
  text: string | null
  type: SeoBlockType
  themeBold: boolean
}

export const SeoBlock: React.FC<Props> = ({ text, type, themeBold }) => {
  return (
    <div className={clsJoin(css.seo_block, themeBold && css.bold, css[type])}>
      <div className={css.seo_block_text}>{text}</div>
    </div>
  )
}
